import { Navigate, Outlet } from 'react-router-dom'
import { FullScreenSpinner } from '@/components/ui/FullScreenSpinner'
import { useAuth } from './AuthContext'

/** Gate for authenticated routes. Redirects anonymous users to /login. */
export function RequireAuth() {
  const { status } = useAuth()
  if (status === 'loading') {
    return <FullScreenSpinner />
  }
  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace />
  }
  return <Outlet />
}
